define('views/components/reseller_product/reseller_product',['require','backbone','text!templates/components/reseller_product/reseller_product.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/reseller_product/reseller_product.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'reseller-product-item'
    });
});
